import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/Service/Common.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-documentwise-productivity',
  templateUrl: './documentwise-productivity.component.html',
  styleUrls: ['./documentwise-productivity.component.css']
})
export class DocumentwiseProductivityComponent implements OnInit {
  projectId!: number;
  groupId!: number;
  userId!: number;
  public reportServer!: string;
  public reportUrl!: string;
  public showParameters!: string;
  public parameters: any;
  public language!: string;
  public height!: number;
  public width!: number;
  public toolbar!: string;


  constructor(private commonService: CommonService) {

  }

  ngOnInit() {
    this.projectId = this.commonService.getProjectId();
    this.groupId = this.commonService.getLoggedInUserGroupId();
    this.userId = this.commonService.getLoggedInUserId();
  }

  public EmbedSSRSReport() {
    this.language = "en-us";
    this.width = 1000;
    this.height = 620;
    this.toolbar = "true";
    this.showParameters = "false";
    this.parameters = {
      "ProjectId": this.projectId,
      "GroupId": this.groupId
    };
  }

  onValueChange(val: { value: string; }) {  
    if (val.value == 'Document') {
      this.parameters = {
        "ProjectId": this.projectId,
        "GroupId": this.groupId
      };
      this.reportServer = environment.reportHost + "EIP40Reports/EIP4EDMS/EDMS/DocumentwiseProductivityReport";
      this.reportUrl = environment.reportHost + "EIP40Reports/EIP4EDMS/EDMS/DocumentwiseProductivityReport";
    }
    if (val.value == 'Discipline') {
      this.parameters = {
        "ProjectId": this.projectId,
        "GroupId": this.groupId
      };
      this.reportServer = environment.reportHost + "EIP40Reports/EIP4EDMS/EDMS/DisciplinewiseProductivityReport";
      this.reportUrl = environment.reportHost + "EIP40Reports/EIP4EDMS/EDMS/DisciplinewiseProductivityReport";
    }
    if (val.value == 'Member') {
      this.parameters = {
        "ProjectId": this.projectId,
        "GroupId": this.groupId,
        "MemberId" : this.userId
      };
      this.reportServer = environment.reportHost + "EIP40Reports/EIP4EDMS/EDMS/MemberwiseProductivityReport";
      this.reportUrl = environment.reportHost + "EIP40Reports/EIP4EDMS/EDMS/MemberwiseProductivityReport";
    }
    if (val.value) {
      this.EmbedSSRSReport();
    }
  }


}
